import {APIService} from "../../common/APIService";
import {Quote} from "../../dto/Quote";
import {Order, OrderStatus} from "../../dto/Order";
import {Supplier} from "../../dto/Supplier";
import {ProjectDisk} from "../../dto/ProjectDisk";

export class OrderService extends APIService {
  public async browseOrders() {
    const json = await this.getJson<{data: object[]}>('orders')
    return json.data.map(item => Order.fromJson(item))
  }

  public async read(id: string) {
    const json = await this.getJson<{data: object}>(`orders/${id}`)
    return Order.fromJson(json.data)
  }

  public async readDisk(projectId: string) {
    const json = await this.getJson<{data: object}>(`orders/${projectId}/disk`)
    return ProjectDisk.fromJson(json.data)
  }

  public async addOrder(quote: Quote|null, projectId: string, relationId: string, contactId: string, amount: number, price: number, requestDate: Date, deliveryDate: Date|null, vatRate: string, ledgerCode: string, description: string, remark: string, status: OrderStatus|null = null) {
    const json = await this.postJson<{data: object[]}>('orders', {
      project_id: projectId,
      ...(quote !== null ? {quote_id: quote.id} : {}),
      supplier_relation_id: relationId,
      supplier_contact_id: contactId,
      amount: amount,
      price: price,
      request_date: requestDate,
      ...(deliveryDate !== null ? {delivery_date: deliveryDate} : {}),
      vat_rate_id: vatRate,
      ledger_code_id: ledgerCode,
      description: description,
      remark: remark,
      ...(status !== null ? {status: status} : {}),
    })
    return Order.fromJson(json.data)
  }

  public async editOrder(order: string, relationId: string, contactId: string, projectId: string, quoteId: string, amount: number, price: number, requestDate: Date, deliveryDate: Date|null, vatRate: string, ledgerCode: string, description: string, remark: string, status: OrderStatus) {
    const json = await this.putJson<{data: object[]}>(`orders/${order}`, {
      project_id: projectId,
      quote_id: quoteId,
      supplier_relation_id: relationId,
      supplier_contact_id: contactId,
      amount: amount,
      price: price,
      status: status,
      request_date: requestDate,
      ...(deliveryDate !== null ? {delivery_date: deliveryDate} : {}),
      vat_rate_id: vatRate,
      ledger_code_id: ledgerCode,
      description: description,
      remark: remark,
    })
    return Order.fromJson(json.data)
  }

  public async sendOrder(orderId: string, toEmail: string, subject: string, text: string, toEmailCC?: string[], files?: File[]) {
    const formData = new FormData()

    formData.append('email_to', toEmail)
    formData.append('email_subject', subject)
    formData.append('email_body', text)

    if (toEmailCC?.length) {
      toEmailCC.forEach(cc => {
        formData.append('email_cc[]', cc)
      })
    }

    files?.forEach((file) => {
      formData.append('files[]', file, file.name)
    })

    await this.putForm<{data: object[]}>(`orders/${orderId}/send`, formData)
  }

  public async deleteOrder(order: string) {
    await this.deleteJson(`orders/${order}`);
  }

  public async downloadPdf(order: string) {
    const response = await this.getRaw(`orders/${order}/pdf`)
    return response.blob()
  }

  public async browseSuppliers() {
    const json = await this.getJson<{data: object[]}>('suppliers')
    return json.data.map(item => Supplier.fromJson(item))
  }
}
